import * as type from './types'


export function createVinWiseOpening(vinWiseOpening) {
    return {
        type : type.CREATE_VIN_WISE_OPENING,
        payload : vinWiseOpening,
        txn : 'initiated',
    };
}


export function savedVinWiseOpening(vinWiseOpening, txn, msg='') {
    return {
        type : type.SAVED_VIN_WISE_OPENING,
        payload : vinWiseOpening,
        txn : txn,
        msg : msg,
        diff : true
    };
}


export function editVinWiseOpening(vinWiseOpening) {
    return {
        type : type.EDIT_VIN_WISE_OPENING,
        payload : vinWiseOpening,
        txn : 'initiated',
    };
}


export function fetchVinWiseOpening() {
    return {
        type : type.FETCH_VIN_WISE_OPENING,
    };
}


export function fetchedVinWiseOpening(vinWiseOpening) {
    return {
        type : type.FETCHED_VIN_WISE_OPENING,
        payload : vinWiseOpening
    };
}


export function searchVinWiseOpening(vinWiseOpening) {
    return {
        type : type.SEARCH_VIN_WISE_OPENING,
        payload : vinWiseOpening
    };
}


export function storeSearchVinWiseOpeningResult(vinWiseOpening) {
    return {
        type : type.STORE_SEARCH_VIN_WISE_OPENING_RESULT,
        payload : vinWiseOpening
    };
}


export function deleteVinWiseOpening(vinWiseOpening) {
    return {
        type : type.DELETE_VIN_WISE_OPENING,
        payload: vinWiseOpening
    };
}


export function deletedVinWiseOpening(msg) {
    return {
        type : type.DELETED_VIN_WISE_OPENING,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_VIN_WISE_OPENING,
        payload: props
    };
}


export function filterItems(options) {
    return {
        type : type.FILTER_ITEMS,
        payload: options
    };
}